<template>
    <div id="wrapper">
        <SidebarView :fixed_deposit="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />
                <div class="container">
                    <div class="card card-shape home-box">
                        <div class="card-header py-3 d-flex flex-row align-items-center">
                            <div>
                                <h6 class="m-0 fw-bold text-green">Standing order</h6>
                                <p class="mb-0 small text-muted">Product order — scheduled transfer from a member’s account</p>
                            </div>
                        </div>
                        <div class="card-body"
                            style="background-color: #eaeff2; border-bottom: 1px solid rgb(1, 134, 115);">
                            <div class="card card-shape home-box mb-3 border border-success">
                                <div class="card-body py-2">
                                    <search :filter="filter" :basicSearch="basicSearch" :action="action"></search>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <single-standing-order
                                :form="form"
                                :submit-busy="submitBusy"
                                :branch-id="branchId"
                                :editing-order-id="editingOrderId"
                                @submit-order="submitStandingOrder"
                            />
                        </div>
                        <div class="card-body">
                            <div>
                                <vue-good-table :isLoading.sync="isLoading" :pagination-options="{
                                    enabled: true,
                                    perPage: serverParams.perPage,
                                }" :rows="rows" :columns="columns">
                                    <!-- Add your custom delete button column -->
                                    <template slot="table-row" slot-scope="props">
                                        <span class="d-flex" v-if="props.column.field == 'action'">
                                            <a title="View" class="btn btn-sm akkurate-warning text-white">
                                                <span class="akkurate-small"> <font-awesome-icon
                                                        :icon="['fas', 'eye']" /></span>
                                            </a>
                                            <approval :data="props.row"></approval>
                                            <a title="Reverse" class="btn btn-sm akkurate-danger-btn text-white">
                                                <span class="akkurate-small"> <font-awesome-icon
                                                        :icon="['fas', 'exchange-alt']" /></span>
                                            </a>
                                        </span>
                                    </template>
                                </vue-good-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>
<script>
import SidebarView from '@/views/main/components/Sidebar.vue';
import TopbarView from '@/views/main/components/Topbar.vue';
import Footer from '@/views/main/components/Footer.vue';
import Search from './form/Search.vue'
import SingleStandingOrder from './form/SingleStandingOrder.vue'
// import AdvanceSearch from './form/AdvanceSearch.vue';
import ApiService from '@/core/services/api.service';
import Approval from './form/modal/Approval.vue'
import ChatBot from '@/views/components/AI/ChatBot.vue';
import { apiErrorMessage } from "@/utils/apiErrorMessage.js";
import {
	STANDING_ORDER_API,
	STANDING_ORDER_CIRCLE_OPTIONS,
	buildProductOrderPayload,
	normalizeStandingOrderCircle,
	resolveCoaSubheadIdForPayload,
	validateBranchId,
	validateCoaSubheadIds,
	validateDistinctAccountNumbers,
	validatePositiveAmount,
	validateSourceBelongsToOrderingCustomer,
	validateStandingOrderCirclePresent,
	validateStandingOrderDateRange,
} from "@/utils/productOrderValidation.js";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Search,
        SingleStandingOrder,

        Approval,
        ChatBot,
        // DepositForm
    },
    data() {
        return {
            submitBusy: false,
            branchId: null,
            editingOrderId: null,
            form: {
                ordering_customer_code: "",
                source_account: null,
                destination_account: null,
                source_coa_id: null,
                destination_coa_id: null,
                amount: "",
                circle: null,
                start_date: "",
                end_date: "",
            },
            filter: {
                code: "",
                search: "",
                branch: "",
                status: "",
                from_date: "",
                to_date: "",
            },
            advSearch: {},
            action: {
                search_btn: "Search",
                disabled_search: false,
            },
            columns: [
                {
                    label: 'SD Code',
                    field: 'id',
                },
                {
                    label: 'Status',
                    field: 'status',
                    type: 'string',
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    type: 'string',
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    type: 'string',
                },
                {
                    label: 'End Date',
                    field: 'end_date',
                    type: 'string',
                },
                {
                    label: 'Duration',
                    field: 'duration',
                    type: 'string',
                },
                {
                    label: 'Circle',
                    field: 'circle',
                    type: 'string',
                },
                {
                    label: 'SRC.Product',
                    field: 'source',
                    type: 'string',
                },
                {
                    label: 'DEST.Product',
                    field: 'destination',
                    type: 'string',
                },
                {
                    label: 'Action',
                    field: 'action',
                },
            ],
            rows: [],
            isLoading: false,
            totalRecords: 0,
            serverParams: {
                columnFilters: {
                },
                sort: [
                    {
                        field: '',
                        type: ''
                    }
                ],
                page: 1,
                perPage: 20
            },

        }
    },
    created() {
        this.loadItems();
    },
    mounted() {
        this.fetchBranchContext();
    },
    methods: {
        async fetchBranchContext() {
            try {
                const response = await ApiService.get("users/profile");
                const u = response && response.data && response.data.user;
                const id =
                    (u && u.branch && u.branch.id) ||
                    (u && u.branch_id);
                if (id != null && id !== "") {
                    this.branchId = Number(id);
                }
            } catch (e) {
                /* branch remains null; submit will validate */
            }
        },
        validationWarning(message) {
            swal.fire({
                icon: "warning",
                title: "Check form",
                text: message,
                confirmButtonText: "OK",
                buttonsStyling: false,
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                },
            });
        },
        successToast(message) {
            swal.fire({
                icon: "success",
                text: message || "Saved.",
                confirmButtonText: "OK",
                buttonsStyling: false,
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                },
            });
        },
        validateStandingOrderForm() {
            const b0 = validateBranchId(this.branchId);
            if (!b0.ok) {
                return b0.message;
            }
            const circleNorm = normalizeStandingOrderCircle(this.form.circle);
            const c0 = validateStandingOrderCirclePresent(circleNorm);
            if (!c0.ok) {
                return c0.message;
            }
            const c1 = validateStandingOrderDateRange(
                this.form.start_date,
                this.form.end_date,
            );
            if (!c1.ok) {
                return c1.message;
            }
            const cAmt = validatePositiveAmount(this.form.amount);
            if (!cAmt.ok) {
                return cAmt.message;
            }
            const c2 = validateSourceBelongsToOrderingCustomer(
                this.form.source_account,
                this.form.ordering_customer_code,
            );
            if (!c2.ok) {
                return c2.message;
            }
            const srcNum =
                this.form.source_account &&
                this.form.source_account.account_number;
            const destNum =
                this.form.destination_account &&
                this.form.destination_account.account_number;
            const c3 = validateDistinctAccountNumbers(srcNum, destNum);
            if (!c3.ok) {
                return c3.message;
            }
            const sc = resolveCoaSubheadIdForPayload(this.form, "source");
            const dc = resolveCoaSubheadIdForPayload(this.form, "destination");
            const cCoa = validateCoaSubheadIds(sc, dc);
            if (!cCoa.ok) {
                return cCoa.message;
            }
            return null;
        },
        async submitStandingOrder() {
            const err = this.validateStandingOrderForm();
            if (err) {
                this.validationWarning(err);
                return;
            }
            const sourceCoa = resolveCoaSubheadIdForPayload(this.form, "source");
            const destinationCoa = resolveCoaSubheadIdForPayload(
                this.form,
                "destination",
            );
            const body = buildProductOrderPayload(this.form, {
                branchId: this.branchId,
                sourceCoa,
                destinationCoa,
            });
            if (
                !Number.isFinite(body.amount) ||
                body.amount <= 0
            ) {
                this.validationWarning(
                    "Enter a valid amount greater than zero.",
                );
                return;
            }
            this.submitBusy = true;
            this.$Progress.start();
            try {
                const response =
                    this.editingOrderId != null
                        ? await ApiService.patch(
                            STANDING_ORDER_API.update(this.editingOrderId),
                            body,
                        )
                        : await ApiService.post(
                            STANDING_ORDER_API.create,
                            body,
                        );
                const d = response && response.data;
                const msg =
                    (d && typeof d.message === "string" && d.message) ||
                    (d &&
                        d.data &&
                        typeof d.data.message === "string" &&
                        d.data.message) ||
                    (this.editingOrderId != null
                        ? "Standing order updated."
                        : "Standing order created.");
                this.successToast(msg);
                this.resetStandingOrderForm();
                await this.loadItems();
            } catch (error) {
                swal.fire({
                    icon: "error",
                    text: apiErrorMessage(
                        error,
                        this.editingOrderId != null
                            ? "Could not update standing order."
                            : "Could not create standing order.",
                    ),
                    confirmButtonText: "OK",
                    buttonsStyling: false,
                    customClass: {
                        confirmButton:
                            "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                    },
                });
            } finally {
                this.submitBusy = false;
                this.$Progress.finish();
            }
        },
        resetStandingOrderForm() {
            this.editingOrderId = null;
            this.form = {
                ordering_customer_code: "",
                source_account: null,
                destination_account: null,
                source_coa_id: null,
                destination_coa_id: null,
                amount: "",
                circle: null,
                start_date: "",
                end_date: "",
            };
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },

        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },

        onSortChange(params) {
            this.updateParams({
                sort: [{
                    type: params.sortType,
                    field: this.columns[params.columnIndex].field,
                }],
            });
            this.loadItems();
        },

        onColumnFilter(params) {
            this.updateParams(params);
            this.loadItems();
        },
        async loadItems() {
            this.isLoading = true;
            await ApiService.query(STANDING_ORDER_API.list, {
                params: {
                    "branch": [], //Eg ["branch1", "branch2"]
                    "startDate": "", // Eg. "2023-12-28"
                    "endDate": "", // Eg. 2023-12-28
                    "status": "" // Eg. "pending"
                }
            }).then((response) => {
                // console.log(response.data.data);
                // console.log(response);
                this.rows = response.data.data.map((index) => {
                    return {
                        id: index.id,
                        status: index.status,
                        amount: index.amount,
                        start_date: index.start_date,
                        end_date: index.end_date,
                        duration: this.calculateDuration(new Date(index.start_date), new Date(index.end_date)),
                        circle: index.circle,
                        source: index.source_coa?.id,
                        destination: index.destination_coa?.id,

                    }
                });
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;

            })
        },

        basicSearch() {
            this.getSingleSD();
        },
        async getSingleSD() {
            this.action.search_btn = "Processing...."
            this.action.disabled_search = true;
            await ApiService.get(STANDING_ORDER_API.show(this.filter.code))
                .then((response) => {
                    // console.log(response.data.data);
                    // response.data.data.map((index) => {
                    //     this.form.source_account = index.source_account?.account_number;
                    //     this.form.source_coa = index.source_coa?.name
                    //     this.form.destination_account = index.destination_account?.account_number;
                    //     this.form.destination_coa = index.destination_coa?.name;
                    //     this.form.amount = index.amount;
                    //     this.form.circle = index.circle;
                    //     this.form.start_date = index.start_date;
                    //     this.form.end_date = index.end_date
                    // });
                    const raw = response.data && response.data.data;
                    const row = raw
                        ? Array.isArray(raw)
                            ? raw[0]
                            : raw
                        : response.data;
                    if (row) {
                        this.editingOrderId =
                            row.id != null ? Number(row.id) : null;
                        if (row.branch_id != null && row.branch_id !== "") {
                            this.branchId = Number(row.branch_id);
                        }
                        const circleNorm = normalizeStandingOrderCircle(
                            row.circle,
                        );
                        let circleOpt = STANDING_ORDER_CIRCLE_OPTIONS.find(
                            (o) => o.value === circleNorm,
                        );
                        if (!circleOpt && circleNorm === "annual") {
                            circleOpt = STANDING_ORDER_CIRCLE_OPTIONS.find(
                                (o) => o.value === "annually",
                            );
                        }
                        const srcCoaId =
                            row.source_coa && row.source_coa.id != null
                                ? Number(row.source_coa.id)
                                : null;
                        const destCoaId =
                            row.destination_coa &&
                            row.destination_coa.id != null
                                ? Number(row.destination_coa.id)
                                : null;
                        this.form = {
                            ...this.form,
                            ...row,
                            ordering_customer_code:
                                row.customer_code ||
                                row.customerCode ||
                                (row.customer && row.customer.code) ||
                                this.form.ordering_customer_code,
                            source_account:
                                row.source_account || this.form.source_account,
                            destination_account:
                                row.destination_account ||
                                this.form.destination_account,
                            source_coa_id: srcCoaId,
                            destination_coa_id: destCoaId,
                            amount: row.amount != null ? row.amount : this.form.amount,
                            start_date: row.start_date || this.form.start_date,
                            end_date: row.end_date || this.form.end_date,
                            circle: circleOpt || null,
                        };
                    }

                    // let payment = this.form.payment;
                    // this.form = response.data.data
                    // let first_name = this.form?.customer?.first_name != null ? this.form?.customer?.first_name : "";
                    // let last_name = this.form?.customer?.last_name != null ? this.form?.customer?.last_name : "";
                    // this.form.customer_name = first_name + ' ' + last_name;
                    // this.form.payment = payment;
                    this.action.search_btn = "Search"
                    this.action.disabled_search = false;
                }).catch((error) => {
                    this.action.search_btn = "Search"
                    this.action.disabled_search = false;
                    swal.fire({
                        icon: "error",
                        text: apiErrorMessage(error, "Could not load standing order."),
                        confirmButtonText: "OK",
                        buttonsStyling: false,
                        customClass: {
                            confirmButton:
                                "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                        },
                    });
                })
        },
        calculateDuration(startDate, endDate) {
            // Convert both dates to milliseconds
            const startMillis = startDate.getTime();
            const endMillis = endDate.getTime();

            // Calculate the difference in milliseconds
            let durationMillis = Math.abs(endMillis - startMillis);

            // Calculate the duration in days, hours, minutes, and seconds
            const millisecondsInDay = 1000 * 60 * 60 * 24;
            const days = Math.floor(durationMillis / millisecondsInDay);
            durationMillis %= millisecondsInDay;
            // const hours = Math.floor(durationMillis / (1000 * 60 * 60));
            // durationMillis %= (1000 * 60 * 60);
            // const minutes = Math.floor(durationMillis / (1000 * 60));
            // durationMillis %= (1000 * 60);
            // const seconds = Math.floor(durationMillis / 1000);

            // Return an object with the duration components
            return days;
            // return {
            //     days: days,
            //     hours: hours,
            //     minutes: minutes,
            //     seconds: seconds
            // };
        }
    }

}

</script>